import { Tag } from '@delmonicos/shared-design-system-react/src/components/tag/tag';
import {
  Text,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { CellContext } from '@tanstack/react-table';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { mapEmspBoRfidBadgeOrderStatusToStyle } from '../emsp-bo-rfid-badge-order-status.helper';

export interface EmspBoRfidBadgeOrderListStatusCellProps
  extends CellContext<
    BackOfficeRfidBadgeOrderModel,
    BackOfficeRfidBadgeOrderModel['status']
  > {}

export const EmspBoRfidBadgeOrderListStatusCell = (
  props: EmspBoRfidBadgeOrderListStatusCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;
  const { t } = useTranslation();

  // RENDER ////////////////////////////////////////////////////////////////////

  const value = getValue();
  const { color } = mapEmspBoRfidBadgeOrderStatusToStyle(value);

  return (
    <Tag className={classNames(color)}>
      <Text italic fontSize={TextFontSize.Small}>
        {t(`delmonicos-shared-sdk.enums-rfid-badge-order-status.${value}`)}
      </Text>
    </Tag>
  );
};
